import React from "react";
import { withStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Switch as MUISwitch } from "@material-ui/core";
import { SwitchClassKey, SwitchProps } from "@material-ui/core/Switch";
import { Colors } from "../../styles";

interface Styles extends Partial<Record<SwitchClassKey, string>> {
    focusVisible?: string;
}

interface Props extends SwitchProps {
    classes: Styles;
}

export const Switch = withStyles((theme: Theme) =>
    createStyles({
        root: {
            width: 55,
            height: 32,
            padding: 0,
            borderRadius: 16,
            backgroundColor: Colors.anthracite25,
            margin: theme.spacing(1),
        },
        switchBase: {
            padding: 1,
            "&$checked": {
                transform: "translateX(23px)",
                color: theme.palette.common.white,
                "& + $track": {
                    backgroundColor: Colors.mellowYellow,
                    opacity: 1,
                    border: "none",
                },
            },
        },
        thumb: {
            width: 30,
            height: 30,
        },
        track: {
            borderRadius: 15,
            border: `1px solid ${Colors.anthracite25}`,
            backgroundColor: Colors.anthracite25,
            opacity: 1,
            transition: theme.transitions.create(["background-color", "border"]),
        },
        checked: {},
        focusVisible: {},
    }),
)(({ classes, ...props }: Props) => {
    return (
        <MUISwitch
            size="medium"
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});
